import { TransitOperation } from '../models/types'
import { fromTransitOperationResponse } from '../models/mapper'
import { createTransitOperationFromEnsV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createTransitFromEns(id: number, withFiles: boolean): Promise<TransitOperation> {
  const response = await createTransitOperationFromEnsV2({
    transitOperationId: id,
    withFiles,
  })

  return fromTransitOperationResponse(response)
}
